function lazyloadImages(selector) {
  function loadImage(picture) {
    if (picture.dataset.loaded) return;

    picture.querySelectorAll("source").forEach((source) => (source.srcset = source.dataset.srcset));

    const img = picture.querySelector("img");
    if (img) img.src = img.dataset.src;

    picture.dataset.loaded = "true";
  }

  const pictures = document.querySelectorAll(`${selector} .lazy-picture`);
  pictures.forEach(loadImage);
}

module.exports = lazyloadImages;
